import { CallReviewPanel } from './CallReviewPanel';
import type { CallRow } from './useRecentCalls';

interface Props {
  selectedCall: CallRow | null;
  prevCall: CallRow | null;
  nextCall: CallRow | null;
  onSelect: (id: string) => void;
  onClose: () => void;
}

export function CallReviewSheet(props: Props): JSX.Element {
  const open = !!props.selectedCall;
  return (
    <div
      role="dialog"
      aria-label="Call review"
      aria-hidden={!open}
      className={[
        'lg:hidden fixed inset-x-0 bottom-14 sm:bottom-0 z-20',
        'h-[60vh] max-h-[60vh]',
        'rounded-t-2xl border-t border-ink-200 bg-white shadow-2xl',
        'flex flex-col',
        'transition-transform duration-200 ease-out',
        open ? 'translate-y-0' : 'translate-y-full pointer-events-none',
      ].join(' ')}
    >
      <div className="mx-auto mt-2 mb-1 h-1 w-10 shrink-0 rounded-full bg-ink-200" aria-hidden />
      <div className="scroll-area flex-1 min-h-0 px-3 pb-3">
        <CallReviewPanel {...props} />
      </div>
    </div>
  );
}
